import { STATUSES } from '@/const/status'
import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'

export default {
  namespaced: true,
  state: {
    statuses: STATUSES,
    certificateProcessTypes: [],
    totalRows: 0,
  },
  getters: {
    statuses: state => state.statuses,
    certificateProcessTypes: state => state.certificateProcessTypes,
    totalRows: state => state.totalRows,
  },
  mutations: {
    SET_STATUSES: (state, statuses) => {
      state.statuses = statuses
    },
    SET_TOTAL_ROWS: (state, total) => {
      state.totalRows = total
    },
    SET_CERTIFICATE_PROCESS_TYPES: (state, certificateProcessTypes) => {
      state.certificateProcessTypes = certificateProcessTypes
    },
  },
  actions: {
    async readCertificateProcessTypes({ commit }, params) {
      try {
        const response = await axios.get('certificates/certificate-process-types', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { total, records } = data.data
          commit('SET_CERTIFICATE_PROCESS_TYPES', records)
          commit('SET_TOTAL_ROWS', total)
        }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async createCertificateProcessTypes({ commit }, params) {
      try {
        const response = await axios.post('certificates/certificate-process-types', params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async updateCertificateProcessType({ commit }, params) {
      try {
        const response = await axios.put(`certificates/certificate-process-types/${params.id}`, params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async deleteCertificateProcessType({ commit }, id) {
      try {
        const response = await axios.delete(`certificates/certificate-process-types/${id}`)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
  },
}
